import { render, staticRenderFns } from "./AromaSecondaryNav.vue?vue&type=template&id=1321585f&scoped=true"
import script from "./AromaSecondaryNav.vue?vue&type=script&lang=js"
export * from "./AromaSecondaryNav.vue?vue&type=script&lang=js"
import style0 from "./AromaSecondaryNav.vue?vue&type=style&index=0&id=1321585f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1321585f",
  null
  
)

export default component.exports